import Provincia from "@/apis/Provincia";

const actions = {
  async getProvincias({ commit }) {
    try {
      const { status, data } = await Provincia.all();
      if (status === 200) {
        commit("setModels", data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response.data);
    }
  },
  async getProvincia({ commit }, id) {
    try {
      const { status, data } = await Provincia.view(id);
      if (status === 200) {
        commit("setModel", data);
      }
    } catch (e) {
      console.log(e);
      commit("setErrors", e.response.data);
    }
  },
};
export default actions;
